import {
	ADD_QUARANTENA_HISTORY_FAIL,
	ADD_QUARANTENA_HISTORY_START,
	ADD_QUARANTENA_HISTORY_SUCCESS,
	ASK_FOR_MONITORAGGIO_FAIL,
	ASK_FOR_MONITORAGGIO_START,
	ASK_FOR_MONITORAGGIO_SUCCESS,
	GENERATE_MONITORAGGIO_FAIL,
	GENERATE_MONITORAGGIO_START,
	GENERATE_MONITORAGGIO_SUCCESS,
	GENERATE_QUARANTENA_FAIL,
	GENERATE_QUARANTENA_START,
	GENERATE_QUARANTENA_SUCCESS,
	GET_ALL_INFO_PROTOCOLLI_FAIL,
	GET_ALL_INFO_PROTOCOLLI_START,
	GET_ALL_INFO_PROTOCOLLI_SUCCESS,
	GET_ALL_INFO_QUARANTENE_FAIL,
	GET_ALL_INFO_QUARANTENE_START,
	GET_ALL_INFO_QUARANTENE_SUCCESS,
	GET_ALL_MONITORAGGI_FAIL,
	GET_ALL_MONITORAGGI_START,
	GET_ALL_MONITORAGGI_SUCCESS,
	GET_FOCOLAIO_FAIL,
	GET_FOCOLAIO_START,
	GET_FOCOLAIO_SUCCESS,
	GET_PROTOCOLLO_FAIL,
	GET_PROTOCOLLO_START,
	GET_PROTOCOLLO_SUCCESS,
	GET_QUARANTENA_FAIL,
	GET_QUARANTENA_HISTORY_FAIL,
	GET_QUARANTENA_HISTORY_START,
	GET_QUARANTENA_HISTORY_SUCCESS,
	GET_QUARANTENA_START,
	GET_QUARANTENA_SUCCESS,
	GET_QUARANTENE_BY_DAY_FAIL,
	GET_QUARANTENE_BY_DAY_START,
	GET_QUARANTENE_BY_DAY_SUCCESS,
	GET_QUARANTENE_BY_MONTH_FAIL,
	GET_QUARANTENE_BY_MONTH_START,
	GET_QUARANTENE_BY_MONTH_SUCCESS,
	MODIFY_ALIAS_FOCOLAIO_FAIL,
	MODIFY_ALIAS_FOCOLAIO_START,
	MODIFY_ALIAS_FOCOLAIO_SUCCESS,
	PROTOCOLLA_PROTOCOLLO_FAIL,
	PROTOCOLLA_PROTOCOLLO_START,
	PROTOCOLLA_PROTOCOLLO_SUCCESS,
	RESET_GET_QUARANTENE_DAY,
	UPDATE_FOCOLAIO_FAIL,
	UPDATE_FOCOLAIO_START,
	UPDATE_FOCOLAIO_SUCCESS,
	UPDATE_PROTOCOLLO_FAIL,
	UPDATE_PROTOCOLLO_START,
	UPDATE_PROTOCOLLO_SUCCESS,
	UPDATE_QUARANTENA_FAIL,
	UPDATE_QUARANTENA_START,
	UPDATE_QUARANTENA_SUCCESS
} from "./actions/ActionTypes";

export const initQuaranteneState = () => {
	return {
		loadingGenerateQuarantena: true,
		errorGenerateQuarantena: "",
		idFocolaio: "",
		loadingGetQuarantena: true,
		errorGetQuarantena: "",
		quarantena: {},
		loadingUpdateQuarantena: true,
		errorUpdateQuarantena: "",
		loadingAddQuarantenaHistory: true,
		errorAddQuarantenaHistory: "",
		loadingGetQuarantenaHistory: true,
		errorGetQuarantenaHistory: "",
		quarantenaHistory: [],
		
		monitoraggi: [],
		loadingGetMonitoraggi: true,
		errorGetMonitoraggi: "",
		
		loadingAskForMonitoraggio: true,
		errorAskForMonitoraggio: "",
		
		loadingGenerateMonitoraggio: true,
		errorGenerateMonitoraggio: "",
		
		loadingGetFocolaio: true,
		errorGetFocolaio: "",
		focolaio: {},
		
		loadingUpdateFocolaio: true,
		errorUpdateFocolaio: "",
		
		loadingGetProtocollo: true,
		errorGetProtocollo: "",
		protocollo: {},
		
		loadingProtocolla: true,
		errorProtocolla: "",
		
		loadingUpdateProtocollo: true,
		errorUpdateProtocollo: "",
		
		loadingGetQuaranteneByMonth: true,
		errorGetQuaranteneByMonth: "",
		quaranteneMonth: {},
		
		loadingGetQuaranteneByDay: true,
		errorGetQuaranteneByDay: "",
		quaranteneDay: [],
		quaranteneDayPayload: [],
		
		loadingGetAllInfo: true,
		errorGetAllInfo: "",
		allInfo: {},
		
		loadingGetAllInfoProtocolli: true,
		errorGetAllInfoProtocolli: "",
		allInfoProtocolli: {},
		
		loadingModifyAlias: true,
		errorModifyAlias: "",
	}
}

export const QUARANTENE_INITIAL_STATE = {}

export const QuaranteneReducer = (state = QUARANTENE_INITIAL_STATE, action) => {
	switch (action.type) {
		default:
			return state;
		case GENERATE_QUARANTENA_START:
			return {
				...state,
				loadingGenerateQuarantena: true,
				errorGenerateQuarantena: "",
				quarantena: {}
			}
		case GENERATE_QUARANTENA_SUCCESS:
			return {
				...state,
				loadingGenerateQuarantena: false,
				errorGenerateQuarantena: "",
				idFocolaio: action.payload,
				quarantena: action.data
			}
		case GENERATE_QUARANTENA_FAIL:
			return {
				...state,
				loadingGenerateQuarantena: false,
				errorGenerateQuarantena: action.error,
				quarantena: {}
			}
		case GET_QUARANTENA_START:
			return {
				...state,
				quarantena: {},
				loadingGetQuarantena: true,
				errorGetQuarantena: "",
			}
		case GET_QUARANTENA_SUCCESS:
			return {
				...state,
				quarantena: action.payload,
				loadingGetQuarantena: false,
				errorGetQuarantena: "",
			}
		case GET_QUARANTENA_FAIL:
			return {
				...state,
				quarantena: {},
				loadingGetQuarantena: false,
				errorGetQuarantena: action.error,
			}
		case UPDATE_QUARANTENA_START:
			return {
				...state,
				loadingUpdateQuarantena: true,
				errorUpdateQuarantena: "",
			}
		case UPDATE_QUARANTENA_SUCCESS:
			return {
				...state,
				quarantena: action.payload,
				loadingUpdateQuarantena: false,
				errorUpdateQuarantena: "",
			}
		case UPDATE_QUARANTENA_FAIL:
			return {
				...state,
				loadingUpdateQuarantena: false,
				errorUpdateQuarantena: action.error,
			}
		case ADD_QUARANTENA_HISTORY_START:
			return {
				...state,
				loadingAddQuarantenaHistory: true,
				errorAddQuarantenaHistory: "",
			}
		case ADD_QUARANTENA_HISTORY_SUCCESS:
			return {
				...state,
				loadingAddQuarantenaHistory: false,
				errorAddQuarantenaHistory: "",
			}
		case ADD_QUARANTENA_HISTORY_FAIL:
			return {
				...state,
				loadingAddQuarantenaHistory: false,
				errorAddQuarantenaHistory: action.error,
			}
		case GET_QUARANTENA_HISTORY_START:
			return {
				...state,
				loadingGetQuarantenaHistory: true,
				errorGetQuarantenaHistory: "",
				quarantenaHistory: [],
			}
		case GET_QUARANTENA_HISTORY_SUCCESS:
			return {
				...state,
				loadingGetQuarantenaHistory: false,
				errorGetQuarantenaHistory: "",
				quarantenaHistory: action.payload,
			}
		case GET_QUARANTENA_HISTORY_FAIL:
			return {
				...state,
				loadingGetQuarantenaHistory: false,
				errorGetQuarantenaHistory: action.error,
				quarantenaHistory: [],
			}
		case GENERATE_MONITORAGGIO_START:
			return {
				...state,
				loadingGenerateMonitoraggio: true,
				errorGenerateMonitoraggio: "",
			}
		case GENERATE_MONITORAGGIO_SUCCESS:
			return {
				...state,
				loadingGenerateMonitoraggio: false,
				errorGenerateMonitoraggio: "",
			}
		case GENERATE_MONITORAGGIO_FAIL:
			return {
				...state,
				loadingGenerateMonitoraggio: false,
				errorGenerateMonitoraggio: action.error,
			}
		case GET_ALL_MONITORAGGI_START:
			return {
				...state,
				monitoraggi: [],
				loadingGetMonitoraggi: true,
				errorGetMonitoraggi: "",
			}
		case GET_ALL_MONITORAGGI_SUCCESS:
			return {
				...state,
				monitoraggi: action.payload,
				loadingGetMonitoraggi: false,
				errorGetMonitoraggi: "",
			}
		case GET_ALL_MONITORAGGI_FAIL:
			return {
				...state,
				monitoraggi: [],
				loadingGetMonitoraggi: false,
				errorGetMonitoraggi: action.error,
			}
		case ASK_FOR_MONITORAGGIO_START:
			return {
				...state,
				loadingAskForMonitoraggio: true,
				errorAskForMonitoraggio: "",
			}
		case ASK_FOR_MONITORAGGIO_SUCCESS:
			return {
				...state,
				loadingAskForMonitoraggio: false,
				errorAskForMonitoraggio: "",
			}
		case ASK_FOR_MONITORAGGIO_FAIL:
			return {
				...state,
				loadingAskForMonitoraggio: false,
				errorAskForMonitoraggio: action.error,
			}
		case GET_FOCOLAIO_START:
			return {
				...state,
				loadingGetFocolaio: true,
				errorGetFocolaio: "",
				focolaio: {}
			}
		case GET_FOCOLAIO_SUCCESS:
			return {
				...state,
				loadingGetFocolaio: false,
				errorGetFocolaio: "",
				focolaio: action.payload
			}
		case GET_FOCOLAIO_FAIL:
			return {
				...state,
				loadingGetFocolaio: false,
				errorGetFocolaio: action.error,
				focolaio: {}
			}
		case UPDATE_FOCOLAIO_START:
			return {
				...state,
				loadingUpdateFocolaio: true,
				errorUpdateFocolaio: ""
			}
		case UPDATE_FOCOLAIO_SUCCESS:
			return {
				...state,
				loadingUpdateFocolaio: false,
				errorUpdateFocolaio: ""
			}
		case UPDATE_FOCOLAIO_FAIL:
			return {
				...state,
				loadingUpdateFocolaio: false,
				errorUpdateFocolaio: action.error
			}
		case GET_PROTOCOLLO_START:
			return {
				...state,
				loadingGetProtocollo: true,
				errorGetProtocollo: "",
				protocollo: {},
			}
		case GET_PROTOCOLLO_SUCCESS:
			return {
				...state,
				loadingGetProtocollo: false,
				errorGetProtocollo: "",
				protocollo: action.payload,
			}
		case GET_PROTOCOLLO_FAIL:
			return {
				...state,
				loadingGetProtocollo: false,
				errorGetProtocollo: action.error,
				protocollo: {},
			}
		case PROTOCOLLA_PROTOCOLLO_START:
			return {
				...state,
				loadingProtocolla: true,
				errorProtocolla: "",
			}
		case PROTOCOLLA_PROTOCOLLO_SUCCESS:
			return {
				...state,
				loadingProtocolla: false,
				errorProtocolla: "",
			}
		case PROTOCOLLA_PROTOCOLLO_FAIL:
			return {
				...state,
				loadingProtocolla: false,
				errorProtocolla: action.error,
			}
		case UPDATE_PROTOCOLLO_START:
			return {
				...state,
				loadingUpdateProtocollo: true,
				errorUpdateProtocollo: "",
			}
		case UPDATE_PROTOCOLLO_SUCCESS:
			return {
				...state,
				loadingUpdateProtocollo: false,
				errorUpdateProtocollo: "",
			}
		case UPDATE_PROTOCOLLO_FAIL:
			return {
				...state,
				loadingUpdateProtocollo: false,
				errorUpdateProtocollo: action.error,
			}
		case GET_QUARANTENE_BY_MONTH_START:
			return {
				...state,
				loadingGetQuaranteneByMonth: true,
				errorGetQuaranteneByMonth: "",
				quaranteneMonth: {},
			}
		case GET_QUARANTENE_BY_MONTH_SUCCESS:
			return {
				...state,
				loadingGetQuaranteneByMonth: false,
				errorGetQuaranteneByMonth: "",
				quaranteneMonth: action.payload,
			}
		case GET_QUARANTENE_BY_MONTH_FAIL:
			return {
				...state,
				loadingGetQuaranteneByMonth: false,
				errorGetQuaranteneByMonth: action.error,
				quaranteneMonth: {},
			}
		case RESET_GET_QUARANTENE_DAY:
			return {
				...state,
				quaranteneDay: [],
			}
		case GET_QUARANTENE_BY_DAY_START:
			return {
				...state,
				loadingGetQuaranteneByDay: true,
				errorGetQuaranteneByDay: "",
				quaranteneDayPayload: [],
			}
		case GET_QUARANTENE_BY_DAY_SUCCESS:
			let newState = [...state.quaranteneDay, ...action.payload];
			return {
				...state,
				loadingGetQuaranteneByDay: false,
				errorGetQuaranteneByDay: "",
				quaranteneDayPayload: action.payload,
				quaranteneDay: newState.filter((object, index) => index === newState.findIndex(obj => JSON.stringify(obj) === JSON.stringify(object)))
				//quaranteneDay: [...state.quaranteneDay, ...action.payload],
			}
		case GET_QUARANTENE_BY_DAY_FAIL:
			return {
				...state,
				loadingGetQuaranteneByDay: false,
				errorGetQuaranteneByDay: action.error,
				quaranteneDay: [],
				quaranteneDayPayload: [],
			}
		case GET_ALL_INFO_QUARANTENE_START:
			return {
				...state,
				loadingGetAllInfo: true,
				errorGetAllInfo: "",
				allInfo: {},
			}
		case GET_ALL_INFO_QUARANTENE_SUCCESS:
			return {
				...state,
				loadingGetAllInfo: false,
				errorGetAllInfo: "",
				allInfo: action.payload,
			}
		case GET_ALL_INFO_QUARANTENE_FAIL:
			return {
				...state,
				loadingGetAllInfo: false,
				errorGetAllInfo: action.error,
				allInfo: {},
			}
		case GET_ALL_INFO_PROTOCOLLI_START:
			return {
				...state,
				loadingGetAllInfoProtocolli: true,
				errorGetAllInfoProtocolli: "",
				allInfoProtocolli: {},
			}
		case GET_ALL_INFO_PROTOCOLLI_SUCCESS:
			return {
				...state,
				loadingGetAllInfoProtocolli: false,
				errorGetAllInfoProtocolli: "",
				allInfoProtocolli: action.payload,
			}
		case GET_ALL_INFO_PROTOCOLLI_FAIL:
			return {
				...state,
				loadingGetAllInfoProtocolli: false,
				errorGetAllInfoProtocolli: action.error,
				allInfoProtocolli: {},
			}
		case MODIFY_ALIAS_FOCOLAIO_START:
			return {
				...state,
				loadingModifyAlias: true,
				errorModifyAlias: "",
			}
		case MODIFY_ALIAS_FOCOLAIO_SUCCESS:
			return {
				...state,
				loadingModifyAlias: false,
				errorModifyAlias: "",
			}
		case MODIFY_ALIAS_FOCOLAIO_FAIL:
			return {
				...state,
				loadingModifyAlias: false,
				errorModifyAlias: action.error,
			}
	}
}
